import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IJobDetailListItem } from './job-detail-list.data';
import { List } from 'immutable';

@Component({
  selector: 'i2g-job-detail-list',
  templateUrl: 'job-detail-list.component.html',
  styleUrls: ['job-detail-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobDetailListComponent implements OnInit {
  @Input() listItems: List<IJobDetailListItem>;

  constructor() {}

  ngOnInit() {}
}
